import { Controller } from '@hotwired/stimulus'

// Proof-of-pipeline controller: confirms Stimulus is wired through the
// esbuild build and the manual manifest. Mounts via data-controller="hello"
// with a data-hello-target="output" element.
export default class extends Controller {
  static targets = ['output']

  connect() {
    this.outputTarget.textContent = 'Hello, Stimulus!'
  }

  // No disconnect() needed: this controller allocates no listeners, timers, or
  // library instances. Controllers that do (Bootstrap components, intervals,
  // subscriptions) MUST implement disconnect() for Turbo compatibility — see
  // app/javascript/CLAUDE.md.
}
